/* Offline-Stand gemeinsam geschriebener Seiten im Browser (klein, ohne Yjs – auch beim Abmelden geladen) */

export const draftKey = (userId: string, pageId: string) => `werft.ydoc.${userId}.${pageId}`;
export interface StoredDraft {
  docId: string;
  update: string;
}
export function readDraft(key: string): StoredDraft | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as StoredDraft) : null;
  } catch {
    return null;
  }
}
export function writeDraft(key: string, d: StoredDraft | null) {
  try {
    if (d) localStorage.setItem(key, JSON.stringify(d));
    else localStorage.removeItem(key);
  } catch {
    /* Speicher voll oder gesperrt: dann nur im Speicher dieses Tabs */
  }
}
/** Abmelden: alle Offline-Stände dieser Person entfernen */
export function clearDocDrafts(userId: string) {
  try {
    for (const k of Object.keys(localStorage)) if (k.startsWith(`werft.ydoc.${userId}.`)) localStorage.removeItem(k);
  } catch {
    /* egal */
  }
}

